import React, { Component } from 'react';
import * as $ from 'jquery';
import moment from 'moment-timezone';
import RejectDialog from './RejectDialog.js';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { SCREEN_WIDTH } from '../../App.js';
import axios from 'axios';
import Media from "react-media";
import { STATUS } from './SDeliveryContainer.js';
import { MENU } from '../Sidebar.js';

let cancelToken;
let state;
let tokenSession;

class Service extends Component {

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  getInitState = () => {
    return {
      services: null
    };
  }

  render() {
    const functionHidden = this.props.isFunctionHidden(MENU.SDELIVERY);
    const { t } = this.props;
    const sdelivery = JSON.parse(this.props.location.state.sdelivery);
    const canBeUpdated = (sdelivery.status === 'Pendiente')? true : false;
    let status;
    let rejected = false;

    switch (sdelivery.status_id) {
      default:
      case STATUS.PENDING:
        status = t('dashboard.sdelivery.status_pending');
        break;
      case STATUS.APPROVED:
        status = t('dashboard.sdelivery.status_approved');
        break;
      case STATUS.REJECTED:
        status = t('dashboard.sdelivery.status_rejected');
        rejected = true;
        break;
      case STATUS.CANCELED:
        status = t('dashboard.sdelivery.status_canceled');
        break;
      case STATUS.FORCED:
        status = t('dashboard.sdelivery.status_forced');
        break;
    }

    return(
      <div>
        <h2 className="page-header">
          {t('dashboard.sdelivery.heading')}
          {canBeUpdated && !functionHidden && this.renderStatusButtons()}
        </h2>
        {!canBeUpdated && this.renderStatusHeader(status,sdelivery.socio_termino)}
        {rejected && this.renderReasonHeader()}
        <br />
        {this.state.services && this.renderServices()}
        <br /><br />
        <Link className=""/*"btn btn-primary btn-sm"*/ to="/sdelivery">
          <i className="fa fa-fw fa-arrow-left" />&nbsp;
          {t('dashboard.btn_back')}
        </Link>
        {this.renderRejectDialog()}
      </div>
    );
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
    state = this.state;
    tokenSession = this.props.getTokenSession();
  }

  componentDidMount() {
    this.reload();
  }

  reload = () => {
    const sdelivery = JSON.parse(this.props.location.state.sdelivery);
    this.getServices({
      token_id: this.props.getTokenId(),
      token_session: this.props.getTokenSession(),
      service_delivery_id: sdelivery.id
    });
  }

  getServices = (params) => {
    this.props.post(
      "/viewServicesDelivery",
      params,
      (response) => this.didGetServices(response),
      (error) => this.handleErrorResponse(error),
      cancelToken
    );
  }

  handleErrorResponse = (error) => {
    alert(error);
    window.location.href = "/sdelivery";
  }

  didGetServices(response) {
    this.setState({ services: response });
  }

  renderServices = () => {
    const services = this.state.services;
    return(
      <div>
        <Media query={"(min-width: " + SCREEN_WIDTH.LARGE + "px)"}>
          {(matches) =>
            matches ? (
              services.map((_, index) => !(index % 3) &&
                <div className="row" key={index}>
                  {this.renderService(services[index], index)}
                  {services[index + 1] && this.renderService(services[index + 1], index + 1)}
                  {services[index + 2] && this.renderService(services[index + 2], index + 2)}
                </div>
              )
            ) : (
              services.map((_, index) => !(index % 2) &&
                <div className="row" key={index}>
                  {this.renderService(services[index], index)}
                  {services[index + 2] && this.renderService(services[index + 1], index + 1)}
                </div>
              )
            )
          }
        </Media>
      </div>
    );
  }

  renderStatusButtons = () => {
    const sdelivery = JSON.parse(this.props.location.state.sdelivery);
    const { t } = this.props;

      return(
        <div className="pull-right">
            <button
              className="btn btn-success btn-lg"
              onClick={() => 
                this.updateSDeliveryStatus({
                  token_id: this.props.getTokenId(),
                  token_session: this.props.getTokenSession(),
                  service_delivery_id: sdelivery.id,
                  button: 1
                })
              }
              type="button">
              {t('dashboard.sdelivery.btn_accept')}
            </button>
          
          &nbsp; &nbsp; &nbsp; &nbsp;

            <button
              className="btn btn-danger btn-lg"
              data-target="#modalReject"
              data-toggle="modal"
              type="button">
              {t('dashboard.sdelivery.btn_reject')}
            </button>
          
            <button
              className="hidden"
              id="btnReject"
              onClick={
                () => 
                this.updateSDeliveryStatus({
                  token_id: this.props.getTokenId(),
                  token_session: this.props.getTokenSession(),
                  service_delivery_id: sdelivery.id,
                  button: 0,
                  motivo: $('#reasonInput').val()
                })
              }
              type="button">
            </button>
          
        </div>
      );
        
  }

  renderStatusHeader = (status,name) => {
    const { t } = this.props;
      return(
        <h3>
          <span className="text-primary"><strong>
            {t('dashboard.sdelivery.heading_status') + ' '}
          </strong></span>
          {status}
          {name && ' ' + t('dashboard.sdelivery.status_text') + ' ' + name}
        </h3>
      );
  }

  renderReasonHeader = () => {
    const sdelivery = JSON.parse(this.props.location.state.sdelivery);
    const { t } = this.props;
      return(
        <h4>
          <span className="text-primary"><strong>
            {t('dashboard.sdelivery.heading_reason') + ' '}
          </strong></span>
          {sdelivery.motivo}
        </h4>
          
      );
  }

  renderService = (service, index) => {
    const sdelivery = JSON.parse(this.props.location.state.sdelivery);
    const date = moment(service.fecha_servicio, 'YYYY-MM-DD HH:mm:ss');
    let panelStyle;

    switch (sdelivery.status_id) {
      default:
      case STATUS.PENDING:
        panelStyle = "panel panel-warning";
        break;
      case STATUS.APPROVED:
        panelStyle = "panel panel-success";
        break;
      case STATUS.REJECTED:
        panelStyle = "panel panel-danger";
        break;
      case STATUS.CANCELED:
        panelStyle = "panel panel-default";
        break;
      case STATUS.FORCED:
        panelStyle = "panel panel-danger";
        break;
    }

    return(
      <div className="col-md-6 col-lg-4" key={index}>
        <div className={panelStyle}>
          <div className="panel-heading">
            <span>
              <h4 className="panel-title">{service.servicio}</h4>
            </span>
          </div>
          <hr />
          <div className="panel-body">
            <span>{service.descripcion}</span>
          </div>
          <hr />
          <div className="panel-body">
            <span>{"Cantidad: " + service.cantidad}</span>
          </div>
          <hr />
          {service.descuento > 0 ? (
            <div className="panel-body">
              <span>{"Descuentos: " + service.descuento }</span>
            </div>
                    
          ): null}
          {service.descuento > 0 ? (
            <div className="panel-body">
              <span>{"Precio Unitario : " + service.costo_unitario }</span>
            </div>
                    
          ): null}
          <hr />
          <div className="panel-body">
            <span>{"Costo total: " + service.costo_total + ' ' + service.moneda}</span>
          </div>
          <hr />
          <div className="panel-body">
            <span>{"Tipo de servicio: " + service.tipo}</span>
          </div>
          <hr />
          <div className="panel-body">
            <span>{date.format('DD-MM-YYYY')}</span>
          </div>
        </div>
      </div>
    );
  }


  updateSDeliveryStatus = (params) => {
    this.props.post(
      "/ServiceDeliveryStatus",
      params,
      (response) => this.didUpdateStatus(response),
      (error) => this.props.handleErrorResponse(error),
      cancelToken
    );
  }

  didUpdateStatus(response) {
    this.props.history.push('/sdelivery')
  }


  renderRejectDialog = () => {
    return(
      <RejectDialog />
    );
  }


}

export default compose(
  translate('common'),
  withRouter
)(Service);



// WEBPACK FOOTER //
// ./src/dashboard/sdelivery/Service.js